module.exports = "div.card.card-profile-left > div.card-body > h4.card-title {\n  color: rgb(4, 146, 210);\n  text-align: right;\n\n}\n"